import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { AbstractSelect } from '@components/field_form/selects/abstract-select';
import { AbstractClass } from '@classes/abstract.class';
import { MAT_SELECT_CONFIG } from "@angular/material/select";
import { RolGroupService } from '@services/admin/rol-group.service';
import {UserRolService} from "@services/admin/user-rol.service";

@Component({
  standalone: false,
  selector: 'app-field-form-select-user-rol',
  templateUrl: './select-user-rol.component.html',
  styleUrls: ['./select-user-rol.component.scss'],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'overlay_custom_select' }
    }
  ]
})
export class SelectUserRolComponent extends AbstractSelect implements OnInit {
  @Input() public myClass: AbstractClass | null = null;
  @Input() label = '';
  @Input() name = '';
  @Input() required = false;

  public list: any[] = [];
  public selectTemporal: any[] = [];

  constructor(
    public service: UserRolService
  ) {
    super(service);
  }

  ngOnInit(): void {
    this.loadData();
  }

  public loadData = () => {
    this.service.getAll().then(
      (data) => {
        if (data === true) {
          this.list = this.service.data.data;
        }
      }
    );
  }
}
